import React, { Component } from 'react';
import MediaQuery from 'react-responsive';
import { Parallax } from 'react-parallax';
import Gallery from 'react-photo-gallery';
import Lightbox from 'react-images';

import './Page.css';
import data from '../data/data.json';
import meetings from '../data/meetings.json';

import Navigation from './Navigation';
import Footer from '../components/Footer';

class PageMeetingGallery extends Component {
  constructor({ match }) {
    super();
    this.state = { currentImage: 0 };
    this.closeLightbox = this.closeLightbox.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);

    const gallery = meetings.find(({ year }) => year === match.params.year);

    this.state = {
      navigation: data.navigation,
      footer: data.club.contact,
      gallery,
    };
  }

  openLightbox(event, obj) {
    this.setState({
      currentImage: obj.index,
      lightboxIsOpen: true,
    });
  }
  closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    });
  }
  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }
  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }

  render() {
    return (
      <div>
        <Navigation navigation={this.state.navigation} />
        <div id="head">
          <Parallax blur={0} bgImage={this.state.gallery.img} bgImageAlt={this.state.gallery.title} strength={120}>
            <MediaQuery query="(max-width: 576px)">
              <div style={{ height: '250px' }} />
            </MediaQuery>
            <MediaQuery query="(min-width: 577px) and (max-width: 768px)">
              <div style={{ height: '350px' }} />
            </MediaQuery>
            <MediaQuery query="(min-width: 769px) and (max-width: 991px)">
              <div style={{ height: '450px' }} />
            </MediaQuery>
            <MediaQuery query="(min-width: 992px)">
              <div style={{ height: '600px' }} />
            </MediaQuery>
          </Parallax>
          <div className="container">
            <div className="row">
              <h1 id="title">{this.state.gallery.title}</h1>
            </div>
          </div>
        </div>
        <section>
          <div className="container">
            <h3>{this.state.gallery.desc}</h3>
            <Gallery photos={this.state.gallery.photos} onClick={this.openLightbox} />
            <Lightbox
              images={this.state.gallery.photos}
              onClose={this.closeLightbox}
              onClickPrev={this.gotoPrevious}
              onClickNext={this.gotoNext}
              currentImage={this.state.currentImage}
              isOpen={this.state.lightboxIsOpen}
            />
          </div>
        </section>
        <Footer footer={this.state.footer} />
      </div>
    );
  }
}
export default PageMeetingGallery;



// WEBPACK FOOTER //
// ./src/components/PageMeetingGallery.js